import { classNames } from "../../../common/lib/classNames";

const HEX_COLOR_REGEX = /^#[0-9a-fA-F]{6}$/;

/** Relative luminance based text contrast: dark text on light colors, white on dark */
function contrastText(hex: string) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  return luminance > 0.6 ? `#1f2937` : `#ffffff`;
}

interface ITagBadgeProps {
  name: string;
  /** Hex color like #1d76db. Falls back to gray styling when missing/invalid */
  color?: string | null;
  className?: string;
  children?: React.ReactNode;
}

export function TagBadge({ name, color, className, children }: ITagBadgeProps) {
  const validColor = color && HEX_COLOR_REGEX.test(color) ? color : null;

  return (
    <span
      className={ classNames(
        `inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium max-w-fit`,
        !validColor && `bg-gray-100 text-gray-800`,
        className,
      ) }
      style={ validColor ? {
        backgroundColor: validColor,
        color: contrastText(validColor),
      } : undefined }
    >
      { name }
      { children }
    </span>
  );
}
